(() => {
  if (window.vndCharacterCardScenes) return;
  const initialized = new WeakSet();
  const selector = 'img[data-character-scenes]';

  function initialize(root = document, reload = false) {
    const images = [...root.querySelectorAll(selector)];
    if (root.matches?.(selector)) images.unshift(root);
    images.forEach((image) => {
      if (!reload && initialized.has(image)) return;
      let sources;
      try { sources = JSON.parse(image.dataset.characterScenes); } catch { return; }
      if (!Array.isArray(sources) || sources.length !== 5) return;
      const valid = sources.every((source) => typeof source === 'string'
        ? source.length > 0
        : source && typeof source.src === 'string' && source.src.length > 0
          && typeof source.srcset === 'string' && typeof source.sizes === 'string');
      if (!valid) return;
      initialized.add(image);
      const selected = sources[Math.floor(Math.random() * sources.length)];
      if (typeof selected === 'string') {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = selected;
      } else {
        image.sizes = selected.sizes;
        image.srcset = selected.srcset;
        image.src = selected.src;
      }
    });
  }

  window.vndCharacterCardScenes = { initialize };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target, true));
  window.addEventListener('pageshow', (event) => { if (event.persisted) initialize(document, true); });
})();
